import './index.scss'

export const Legend = () => {
    return (
        <div className="legend">
            <strong className="legend__title">Legenda:</strong>
            <div className="legend__items">
                <div className="legend__item">
                    <div className="legend__color legend__color--green" />
                    <span>*Entre 0.01% e 5%</span>
                </div>
                <div className="legend__item">
                    <div className="legend__color legend__color--orange" />
                    <span>*Entre 5.01% e 15% </span>
                </div>
                <div className="legend__item">
                    <div className="legend__color legend__color--black" />
                    <span>*Maior que 15%</span>
                </div>
                <div className="legend__item">
                    <div className="legend__color legend__color--purple" />
                    <span>Produto sem pedido</span>
                </div>
                <div className="legend__item">
                    <div className="legend__color legend__color--blue" />
                    <span>Preço vencedor maior que preço digitado</span>
                </div>
            </div>
            <span className="legend__note">* mais barato</span>
        </div>

        // 0,01 e 5% / 5.01 e 15%  / > 15% / azul - preço vencedor > preço digitado /
    )
}
